// src/pages/pedidos/ConfigWhatsCad.js
// pages/pedidos/ConfigWhatsCad.js
import React, { useEffect, useState } from 'react';
import { IoIosSave } from "react-icons/io";
import Input from '../../components/input/Input';
import InputCheck from '../../components/input/InputCheck';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import { useMessage } from '../../contexts/geral/MessageContext';
import { useConfigWhats } from '../../contexts/pedidos/ConfigWhatsContext';
import { FaWhatsapp } from 'react-icons/fa';
import StatusConexaoWhats, { getDescricaoStatusConexaoWhats } from '../../models/pedidos/StatusConexaoWhats';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const ConfigWhatsCad = ({ show, onHide }) => {
    const { configWhats, setConfigWhats, insertConfigWhats, updateConfigWhats, conectarWhats, createInstance, consultarStatusConexao } = useConfigWhats();
    const { showMessage } = useMessage();

    //status dos botões
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [loadingConnect, setLoadingConnect] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [showQrCode, setShowQrCode] = useState(false);
    const [statusConexao, setStatusConexao] = useState();
    const [erroStatusConexao, setErroStatusConexao] = useState(false);
    const [monitorarConexao, setMonitorarConexao] = useState(false);

    useEffect(() => {
        if (show) {
            setShowQrCode(false);
            setMonitorarConexao(false);
        }
    }, [show]);

    useEffect(() => {
        if (!show || !configWhats?.id) return;

        let ativo = true;

        const verificarStatusConexao = async () => {
            try {
                const status = await consultarStatusConexao();

                if (!ativo) return;

                setStatusConexao(status);
                setErroStatusConexao(false);

                if (status?.conectado) {
                    setMonitorarConexao(false);
                    setShowQrCode(false);
                }
            } catch (error) {
                if (!ativo) return;

                setErroStatusConexao(true);
                console.error('Erro ao consultar o status da conexão do WhatsApp:', error);
            }
        };

        verificarStatusConexao();

        const intervalo = monitorarConexao
            ? setInterval(verificarStatusConexao, 1000)
            : null;

        return () => {
            ativo = false;
            if (intervalo) clearInterval(intervalo);
        };
    }, [show, configWhats?.id, monitorarConexao, consultarStatusConexao]);

    const handleSave = async () => {
        if (!configWhats?.instance || !configWhats?.telefone) {
            showMessage("Todos os campos devem ser preenchidos!");
            return;
        }

        setLoadingSave(true);

        try {
            const configWhatsSemQrCode = { ...configWhats, qrCode: null };
            setShowQrCode(false);
            setConfigWhats(configWhatsSemQrCode);
            if (configWhatsSemQrCode.id) {
                await updateConfigWhats(configWhatsSemQrCode);
            } else {
                await insertConfigWhats(configWhatsSemQrCode);
            }
            onHide();
        } catch (error) {
            console.error("Erro ao salvar configuração:", error);
        } finally {
            setLoadingSave(false);
        }
    };

    const handleConectarWhats = async () => {
        setLoadingConnect(true);
        setShowQrCode(false);
        setErroStatusConexao(false);
        setStatusConexao({
            estado: StatusConexaoWhats.Conectando,
            conectado: false,
        });
        try {
            setConfigWhats({ ...configWhats, qrCode: null });
            await conectarWhats(configWhats);
            setShowQrCode(true);
            setMonitorarConexao(true);
        } catch (error) {
            console.error("Erro ao conectar WhatsApp:", error);
        } finally {
            setLoadingConnect(false);
        }
    };

    const handleCreateInstance = async () => {
        setLoadingCreate(true);
        try {
            await createInstance(configWhats);
        } catch (error) {
            console.error("Erro ao criar instância:", error);
        } finally {
            setLoadingCreate(false);
        }
    };

    if (!show) return null;

    const statusConexaoExibicao = erroStatusConexao
        ? { descricao: 'Não foi possível consultar o status', cor: '#dc3545' }
        : getDescricaoStatusConexaoWhats(statusConexao?.estado, statusConexao?.conectado);

    return (
        <ModalContainer show={show} largura='650px' variant="cadastro" onHide={onHide}>
            <ModalHeader title="Configuração do WhatsApp" onHide={onHide} />

            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Nome da Instância"
                            value={configWhats?.instance || ''}
                            onChange={(e) => setConfigWhats({ ...configWhats, instance: e.target.value })}
                            size={200}
                        />
                        <Input
                            label="Telefone"
                            value={configWhats?.telefone || ''}
                            onChange={(e) => setConfigWhats({ ...configWhats, telefone: e.target.value })}
                            size={150}
                            mask="(99) 99999-9999"                            
                        />
                        <InputCheck
                            id="desativarWhats"
                            label="Desativar WhatsApp"
                            checked={!!configWhats?.desativarWhats}
                            onChange={(e) => setConfigWhats({ ...configWhats, desativarWhats: e.target.checked })}
                        />
                    </div>

                    <div className="d-flex align-items-start gap-4 flex-wrap mb-3">
                        {showQrCode && configWhats?.qrCode && (
                            <div className="form-group">
                                <label className="form-label">QR Code</label>
                                <div>
                                    <img
                                        src={configWhats.qrCode}
                                        alt="QR Code"
                                        width={260}
                                        height={260}
                                        style={{ objectFit: 'contain' }}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="form-group">
                            <label className="form-label">Status da conexão</label>
                            <div>
                                <span
                                    className="badge"
                                    style={{ backgroundColor: statusConexaoExibicao.cor }}
                                >
                                    {statusConexaoExibicao.descricao}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
            </ModalBody>

            <ModalFooter>
        <ModalActions >
            <button 
                className="btn btn-secondary" 
                onClick={handleCreateInstance}
                disabled={loadingCreate}
            >
                {loadingCreate ? "Criando..." : "Criar Instância"}
            </button>

            <button 
                className="btn btn-success" 
                onClick={handleConectarWhats}
                disabled={loadingConnect}
            >
                {loadingConnect ? "Conectando..." : <>Conectar <FaWhatsapp /></>}
            </button>

            <ModalActionButton
                className="btn btn-primary" 
                onClick={handleSave}
                disabled={loadingSave}
             action="save">
                {loadingSave ? "Salvando..." : <>Salvar <IoIosSave /></>}
            </ModalActionButton>
        </ModalActions>
            </ModalFooter>
        </ModalContainer>
    );
};

export default ConfigWhatsCad;
